import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/RevealText";
import BeforeAfter from "@/components/BeforeAfter";

export default function CaseStudies({ items = [] }) {
  if (!items.length) return null;
  return (
    <section id="work" className="border-y border-white/10 bg-black scroll-mt-20" data-testid="case-studies-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-40">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 md:mb-24">
          <div>
            <p className="font-mono text-xs tracking-[0.3em] uppercase text-white/40 mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-[color:var(--accent)]" /> Selected work
            </p>
            <h2 className="font-display text-5xl md:text-7xl uppercase tracking-tighter leading-[0.85]">
              Results,<br /><span className="text-white/25">not rhetoric.</span>
            </h2>
          </div>
          <p className="font-mono text-sm text-white/50 max-w-xs">
            Drag the slider on each project to see the transformation — before and after we got involved.
          </p>
        </div>

        <div className="space-y-24 md:space-y-32">
          {items.map((cs, i) => (
            <Reveal key={cs.id}>
              <div className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
                <div className="lg:col-span-7 [direction:ltr]">
                  <BeforeAfter before={cs.after} after={cs.before} className="aspect-[16/10]" />
                </div>
                <div className="lg:col-span-5 [direction:ltr]" data-testid={`case-study-${cs.slug}`}>
                  <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 mb-5">
                    <span className="text-[color:var(--accent)]">{cs.service}</span><span>/</span><span>{cs.year}</span>
                  </div>
                  <h3 className="font-display text-3xl md:text-4xl uppercase tracking-tight leading-tight mb-4">{cs.title}</h3>
                  <p className="font-mono text-sm text-white/55 leading-relaxed mb-8">{cs.summary}</p>
                  <div className="grid grid-cols-3 border-l border-t border-white/10">
                    {cs.metrics.map((m) => (
                      <div key={m.l} className="border-r border-b border-white/10 p-5">
                        <div className="font-display text-2xl md:text-3xl tracking-tighter text-[color:var(--accent)]">{m.v}</div>
                        <div className="font-mono text-[10px] tracking-[0.15em] uppercase text-white/45 mt-1">{m.l}</div>
                      </div>
                    ))}
                  </div>
                  <div className="font-mono text-xs tracking-[0.15em] uppercase text-white/40 mt-6">Client — {cs.client}</div>
                  <Link to={`/work/${cs.slug}`} className="group/link inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-white/70 hover:text-[color:var(--accent)] transition-colors mt-6" data-testid={`case-study-link-${cs.slug}`}>
                    View case study <ArrowUpRight size={14} className="group-hover/link:rotate-45 transition-transform" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
